var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group col-md-6" }, [
    _c("div", { staticClass: "px-3" }, [
      _vm._m(0),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.summary,
            expression: "summary",
          },
        ],
        ref: "summary",
        staticClass: "form-control",
        attrs: { rows: "4", maxlength: "999", disabled: !_vm.canEdit },
        domProps: { value: _vm.summary },
        on: {
          change: _vm.update,
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.summary = $event.target.value
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "form-control-label" }, [
      _c("h5", [_vm._v("Summary")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }